module.exports = __webpack_public_path__ + "us.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/us.svg
// module id = 867
// module chunks = 0